import { render } from "./TheDynamicInputNutritionalAnamnesis.vue?vue&type=template&id=ba1f25d4&ts=true"
import script from "./TheDynamicInputNutritionalAnamnesis.vue?vue&type=script&lang=ts"
export * from "./TheDynamicInputNutritionalAnamnesis.vue?vue&type=script&lang=ts"

import "./TheDynamicInputNutritionalAnamnesis.vue?vue&type=style&index=0&id=ba1f25d4&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__